<div class="host">
	<div class="appearance-header">
		<div class="back-button" appCrossPointerEventTarget (pointerClickEvent)="dialogRef.close()">
			<img [width]="28" [src]="'./assets/Back Button (Blue-White).svg'" />
		</div>
		<div>
			<img [width]="24" [src]="'./assets/Glasses (White).svg'" alt="Glasses (White).svg" />
		</div>
		<div class="ds-dialog-title-white ds-pl-10">
			<span>Appearance</span>
		</div>
	</div>
	<div class="appearance-content">
		<div class="top-content">
			<div class="theme">
				<span>Theme</span>
			</div>
			<app-restriction-picker
				[width]="255"
				[height]="32"
				[choices]="['Light', 'Dark', 'Auto']"
				[selectedChoice]="selectedTheme"
				(result)="setSelectedTheme($event)">
			</app-restriction-picker>
		</div>

		<div class="page-layout" *ngIf="!hideLayoutSettings">
			<div class="header">
				<div class="header-title">Destination Page Layout</div>
				<div class="header-info" *ngIf="!extraLargeDevice || IpadDevice">Switch the layout of the “To where?” page during pass creation.</div>
			</div>
			<div class="picker">
				<app-restriction-picker
					[width]="!extraLargeDevice || IpadDevice ? 141 : 0"
					[height]="32"
					[selectedChoice]="isList ? 'List' : 'Grid'"
					[choices]="['Grid', 'List']"
					(result)="selectedLayout($event)"></app-restriction-picker>
			</div>
			<div class="header-info-mobile" *ngIf="extraLargeDevice && !IpadDevice">Switch the layout of the “To where?” page during pass creation.</div>
		</div>

		<div class="page-layout-wrapper">
			<div class="page-layout" [ngClass]="{ 'page-position': showWrapper }" *ngIf="isStaff">
				<div class="header">
					<div class="header-title">Show Expired Passes</div>
					<div class="header-info">Show expired passes on your home page.</div>
				</div>
				<div class="picker">
					<app-toggle-input
						[delimiter]="false"
						[controlSize]="'small'"
						[form]="form"
						[controlName]="'show_expired_passes'"
						(pushOutValue)="updateUser({ show_expired_passes: $event })"></app-toggle-input>
				</div>
			</div>
			<div class="layout-wrapper" *ngIf="showWrapper"></div>
		</div>
		<div class="page-layout" *ngIf="isStaff && (isEnableProfilePictures$ | async)">
			<div class="header">
				<div class="header-title">Show Profile Pictures</div>
				<div class="header-info">
					Show profile pictures on pass <br />tiles
					<span *ngIf="form.get('show_student_profile_picture').value">: </span>
					<span
						appCrossPointerEventTarget
						(pointerClickEvent)="showLocationPiker = !showLocationPiker"
						class="profile-location"
						*ngIf="form.get('show_student_profile_picture').value">
						{{ showStudentProfileLocation }}
						<img width="8" height="6" [src]="'./assets/Rect (Blue-Gray).svg'" alt="" />
					</span>
				</div>
			</div>
			<div class="picker">
				<app-toggle-input
					[delimiter]="false"
					[controlSize]="'small'"
					[form]="form"
					[controlName]="'show_student_profile_picture'"
					(pushOutValue)="updateProfilePictures($event)"></app-toggle-input>
			</div>
		</div>
		<div class="res-picker" *ngIf="showLocationPiker && form.get('show_student_profile_picture').value">
			<app-restriction-picker
				[width]="186"
				[choices]="['Hall Monitor', 'Everywhere']"
				[selectedChoice]="showStudentProfileLocation"
				(result)="switchProfileLocation($event)"></app-restriction-picker>
		</div>
	</div>
</div>
